<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mLyp6D/tc-custom/9780310096191.jpg?1709151731282" alt="This image is the cover for the book Fall of Lucifer, Chronicles of Brothers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fall of Lucifer, Chronicles of Brothers
      </h1>
      <p class="bookDescription body article font2">
        <p><i>In the beginning…</i></p><p>Three brothers – Gabriel, Michael and Lucifer. Royalty. Archangels. United in devotion to their father and all his works.</p><p>But when Lucifer learns of their father’s latest creation – a new race, fashioned from crude matter and yet made in his image – he is consumed with resentment. Why have he and his angelic kind been overlooked?</p><p>After a bitter confrontation, Lucifer is cast out, doomed to an eternity of exile and punishment.</p><p>Unrepentant, he vows he won’t suffer alone. Mankind has made a powerful enemy – one determined to lure it into darkness and torment any way he can…</p><p><i>“There could be no bigger canvas for film-making.”</i> – Mark Ordesky (Executive Producer – Lord of the Rings);</p><p>“<i>Alec not only re-frames pre-history; she also imaginatively illustrates how the realm of spirit impacts the contemporary material world.”</i> Ileen Maisel (Executive Producer for the Golden Compass)</p><p><i>“This is the best work of fiction I have read since the last installment of Dean Koontz’ Frankenstein series”</i> Jim McDonald – 1340Mag – Online Entertainment Magazine.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wendy Alec
      </h2>
      
      <p class="authorDescription body article"><P>Born in London and brought up in South Africa, Wendy Alec has pursued successful careers in advertising and television production, as well as writing books and screenplays. The cinematic scope and epic sweep of the Chronicles of Brothers series have won her legions of devoted fans around the world</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07e4dc97